import { Text, type TextProps } from "@mantine/core"
import type { PropsWithChildren } from "react"
import { Markdown } from "@/components/utils"
import type { IAnswerProps } from "./types"

export function AnswerComment({
  question,
  answer,
  placeholder = null,
  children,
  ...props
}: PropsWithChildren<IAnswerProps & TextProps> & { placeholder?: React.ReactNode }) {
  if (!question.is_commentable || !answer?.comment) return placeholder
  const isMarkdown = question.type == "personal" && question.is_commentable
  return (
    <>
      {children}
      {isMarkdown ? (
        <Markdown>{answer.comment}</Markdown>
      ) : (
        <Text fz="lg" style={{ whiteSpace: "pre-wrap" }} {...props}>
          {answer.comment}
        </Text>
      )}
    </>
  )
}
